// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3mLQq","filesListContainer":"PosDisputesFiles_filesListContainer__1oqaU","filesButton":"PosDisputesFiles_filesButton__19pl1"};